export const accessKeys = {
  all: ['access'] as const,
  me: () => [...accessKeys.all, 'me'] as const,
  siteAccess: (plantIds: readonly string[]) => [...accessKeys.all, 'site-access', plantIds.join(',')] as const,
  sidebar: () => [...accessKeys.all, 'sidebar'] as const,
};

export const ACCESS_STALE = 5 * 60 * 1000;
export const SITE_ACCESS_STALE = 60 * 1000;
export const ACCESS_GC = 10 * 60 * 1000;
